'use strict';

var dateFns = require('date-fns');
var compositionApi = require('@vue/composition-api');
var styles = require('vue-airbnb-calendar/lib/helpers/styles');

var normalizeRanges = function normalizeRanges(ranges) {
  if (!ranges) {
    return [];
  }

  return (ranges instanceof Function ? ranges() : ranges).map(function (r) {
    return {
      start: dateFns.startOfDay(r.start),
      end: dateFns.startOfDay(r.end)
    };
  });
};
var intervalOverlapsWith = function intervalOverlapsWith(interval, ranges) {
  if (!ranges) {
    return;
  }

  ranges = normalizeRanges(ranges);

  if (!(ranges.length && interval.start && interval.end)) {
    return false;
  }

  var selectionInterval = orderedInterval(interval.start, interval.end);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = ranges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var range = _step.value;

      if (dateFns.areIntervalsOverlapping(selectionInterval, range)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
};
var orderedInterval = function orderedInterval(date1, date2) {
  var start = dateFns.isBefore(date1, date2) ? date1 : date2;
  var end = date1 === start ? date2 : date1;
  return {
    start: start,
    end: end
  };
};
var findRangesOfItem = function findRangesOfItem(item, ranges) {
  return findRangesOfDate(item.date, ranges);
};
var findRangesOfDate = function findRangesOfDate(date, ranges) {
  if (!ranges) {
    return [];
  }

  ranges = normalizeRanges(ranges);
  return ranges.filter(function (range) {
    return dateFns.isWithinInterval(date, range);
  });
};

var makeDateInfo = function makeDateInfo() {
  return {
    reservation: false,
    checkIn: false,
    checkOut: false
  };
};

var getInfo = function getInfo(date, analysis) {
  return analysis[date.getTime()] || (analysis[date.getTime()] = makeDateInfo());
};
var analyzeOptions = function analyzeOptions(options) {
  if (!options) {
    return {};
  }

  var analysis = {};
  var reservationOptions = options.reservations || {};
  var reservationRanges = normalizeRanges(reservationOptions.ranges);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = reservationRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var range = _step.value;
      var dates = dateFns.eachDayOfInterval(range);

      for (var i = 0; i < dates.length; ++i) {
        var date = dates[i];
        var dateInfo = getInfo(date, analysis);
        dateInfo.reservation = true;

        if (i === 0) {
          dateInfo.checkIn = true;
        }

        if (i === dates.length - 1) {
          dateInfo.checkOut = true;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return analysis;
};

var hasReservation = function hasReservation(item, analysis) {
  return !!(analysis && analysis[item.date.getTime()] && analysis[item.date.getTime()].reservation);
};
var validateCheckInOut = function validateCheckInOut(selection, item, analysis, reservationRanges, minDays, options) {
  var resOptions = options.reservations;

  if (!resOptions) {
    return true;
  }

  if (!minDays) {
    return true;
  }

  var maxGap = resOptions.maxGap ? resOptions.maxGap instanceof Function ? resOptions.maxGap({
    selection: selection
  }) : resOptions.maxGap : 0; // validate selection start

  if (!(selection.from || selection.to) || selection.from && selection.to) {
    // shift dates depending on whether check-in & check-out days can overlap
    var shift = resOptions.allowCheckInOutOverlap ? 0 : 1;
    var isCheckIn = getInfo(dateFns.addDays(item.date, shift), analysis).checkIn;
    var isCheckOut = getInfo(dateFns.subDays(item.date, shift), analysis).checkOut; // always allow check-in and check-out days to be selected if resOptions.allowGapFills is true

    if (resOptions.allowGapFills && isCheckOut != isCheckIn) {
      return true;
    }

    if (isCheckOut && !intervalOverlapsWith({
      start: item.date,
      end: dateFns.addDays(item.date, minDays)
    }, reservationRanges)) {
      return true;
    }

    if (isCheckIn && !intervalOverlapsWith({
      start: dateFns.subDays(item.date, minDays),
      end: item.date
    }, reservationRanges)) {
      return true;
    } // allow check-in with a maximum gap to another reservation of maxGap


    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = reservationRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var range = _step.value;

        if (dateFns.isBefore(item.date, range.start)) {
          // check if item.date is in the gap zone before a reservation and minDays is would be fulfilled
          if (dateFns.differenceInDays(range.start, item.date) <= maxGap + shift && !intervalOverlapsWith({
            start: dateFns.subDays(item.date, minDays),
            end: item.date
          }, reservationRanges)) {
            return true;
          }
        } else if (dateFns.isAfter(item.date, range.end)) {
          // check if item.date is in the gap zone after a reservation and minDays is would be fulfilled
          if (dateFns.differenceInDays(item.date, range.end) <= maxGap + shift && !intervalOverlapsWith({
            start: item.date,
            end: dateFns.addDays(item.date, minDays)
          }, reservationRanges)) {
            return true;
          }
        }
      } // check if minDays would be fulfilled

    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (intervalOverlapsWith({
      start: dateFns.subDays(item.date, minDays + shift),
      end: item.date
    }, reservationRanges) || intervalOverlapsWith({
      start: item.date,
      end: dateFns.addDays(item.date, minDays + shift)
    }, reservationRanges)) {
      return false;
    }
  } // validate selection end


  if (selection.from && !selection.to) {
    // shift dates depending on whether check-in & check-out days can overlap
    var _shift = resOptions.allowCheckInOutOverlap ? 0 : 1;

    var interval = orderedInterval(selection.from.date, item.date);
    var days = dateFns.differenceInDays(interval.end, interval.start); // check if selection would wrap a reservation

    if (intervalOverlapsWith(interval, reservationRanges)) {
      return false;
    } // allow gap fills


    if (days < minDays && resOptions.allowGapFills) {
      if (dateFns.isAfter(item.date, selection.from.date) && getInfo(dateFns.addDays(item.date, _shift), analysis).checkIn && getInfo(dateFns.subDays(selection.from.date, _shift), analysis).checkOut) {
        return true;
      } else if (dateFns.isBefore(item.date, selection.from.date) && getInfo(dateFns.subDays(item.date, _shift), analysis).checkOut && getInfo(dateFns.addDays(selection.from.date, _shift), analysis).checkIn) {
        return true;
      }
    }

    var dateInfo = getInfo(item.date, analysis);

    if (days < minDays) {
      return false;
    } // always allow seletion to connect to check-in & check-out days


    if (dateInfo.checkIn != dateInfo.checkOut) {
      return true;
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = reservationRanges[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _range = _step2.value;

        // check if item.date is in the gap zone before or after a reservation and minDays is would be fulfilled
        if (dateFns.isBefore(item.date, _range.start) && dateFns.differenceInDays(_range.start, item.date) <= maxGap + _shift || dateFns.isAfter(item.date, _range.end) && dateFns.differenceInDays(item.date, _range.end) <= maxGap + _shift) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    _shift = resOptions.allowCheckInOutOverlap ? 0 : 2;

    if (dateFns.isBefore(item.date, selection.from.date)) {
      if (intervalOverlapsWith({
        start: dateFns.subDays(interval.start, minDays + _shift),
        end: interval.start
      }, reservationRanges)) {
        return false;
      }
    }

    if (dateFns.isAfter(item.date, selection.from.date)) {
      if (intervalOverlapsWith({
        start: interval.end,
        end: dateFns.addDays(interval.end, minDays + _shift)
      }, reservationRanges)) {
        return false;
      }
    }
  }

  return true;
};

var containers = {};
var selectItem = function selectItem(item, selection) {
  if (selection.value.from && selection.value.to) {
    selection.value = {
      from: item,
      to: null
    };
    return;
  }

  if (!selection.value.from) {
    selection.value.from = item;
    return;
  }

  var from = selection.value.from;
  var to = item;

  if (dateFns.isBefore(to.date, from.date)) {
    to = from;
    from = item;
  }

  selection.value = {
    from: from,
    to: to
  };
};
var clear = function clear(selection) {
  selection.value.from = null;
  selection.value.to = null;
};

var isBeforeMinDate = function isBeforeMinDate(item, minDate) {
  return !!minDate && dateFns.isBefore(item.date, minDate);
};

var isAfterMaxDate = function isAfterMaxDate(item, maxDate) {
  return !!maxDate && dateFns.isAfter(item.date, maxDate);
};

function useSelection(id, options) {
  var _ref = containers[id] || (containers[id] = {
    selection: compositionApi.ref({
      from: null,
      to: null
    }),
    hoverItem: compositionApi.ref(null),
    analysis: compositionApi.ref({})
  }),
      selection = _ref.selection,
      hoverItem = _ref.hoverItem,
      analysis = _ref.analysis;

  var isHovered = function isHovered(item) {
    return !!hoverItem.value && item.date.getTime() === hoverItem.value.date.getTime();
  };

  var isSelected = function isSelected(item) {
    return !!(selection.value.from && selection.value.from.date.getTime() === item.date.getTime() || selection.value.to && selection.value.to.date.getTime() === item.date.getTime());
  };

  var isWithinSelection = function isWithinSelection(item) {
    if (!item.isCurrentMonth) {
      return false;
    }

    var hoverSelection = {
      from: selection.value.from || hoverItem.value,
      to: selection.value.to || hoverItem.value
    };

    if (hoverSelection.from && hoverSelection.to && dateFns.isAfter(hoverSelection.from.date, hoverSelection.to.date)) {
      var from = hoverSelection.from;
      var to = hoverSelection.to;
      hoverSelection.from = to;
      hoverSelection.to = from;
    }

    return !!(hoverSelection.from && hoverSelection.to && dateFns.isWithinInterval(item.date, {
      start: hoverSelection.from.date,
      end: hoverSelection.to.date
    }));
  };

  var isSelectable = function isSelectable(item, analysis, options) {
    if (!item.isCurrentMonth) {
      return false;
    }

    var resOptions = options.reservations || {};
    var minDays = resOptions.minDays instanceof Function ? resOptions.minDays({
      selection: selection.value
    }) : resOptions.minDays || 0;
    var reservationRanges = normalizeRanges(resOptions.ranges || []);
    var selectableRanges = findRangesOfItem(item, options.selectableRanges);
    var beforeMinDate = isBeforeMinDate(item, options.minDate);
    var afterMaxDate = isAfterMaxDate(item, options.maxDate);
    var validCheckInOut = validateCheckInOut(selection.value, item, analysis, reservationRanges, minDays, options);
    var defaultValue = !(options.selectableRanges && !selectableRanges.length || !validCheckInOut || beforeMinDate || afterMaxDate);

    if (options.selectable) {
      return options.selectable(item, {
        selectableRanges: selectableRanges,
        reservationRanges: reservationRanges,
        beforeMinDate: beforeMinDate,
        afterMaxDate: afterMaxDate,
        defaultValue: defaultValue,
        selection: selection.value
      });
    }

    return defaultValue;
  };

  var stopHandles = compositionApi.ref([]);
  stopHandles.value.push(compositionApi.watch(options, function (options) {
    analysis.value = analyzeOptions(options);
  }));

  var destroy = function destroy() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = stopHandles.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var stop = _step.value;
        stop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  return {
    selection: selection,
    selectItem: selectItem,
    hoverItem: hoverItem,
    analysis: analysis,
    isHovered: isHovered,
    clear: clear,
    isSelectable: isSelectable,
    isSelected: isSelected,
    isWithinSelection: isWithinSelection,
    analyzeOptions: analyzeOptions,
    hasReservation: hasReservation,
    isBeforeMinDate: isBeforeMinDate,
    isAfterMaxDate: isAfterMaxDate,
    stopHandles: stopHandles,
    destroy: destroy
  };
}

var renderDay = function renderDay(h, path) {
  return h('div', {
    staticClass: 'AirbnbCalendarItem__checkInOut'
  }, [h('svg', {
    class: 'AirbnbCalendarItem__checkInOut-svg',
    attrs: {
      viewBox: '0 0 100 100',
      preserveAspectRatio: 'none',
      'shape-rendering': 'geometricPrecision'
    }
  }, [h('path', {
    attrs: {
      d: path
    }
  })])]);
};
var renderCheckInDay = function renderCheckInDay(h) {
  return renderDay(h, 'M-1 101 L 101 101 L 101 -1 L -1 101');
};
var renderCheckOutDay = function renderCheckOutDay(h) {
  return renderDay(h, 'M-1 -1 L 101 -1 L -1 101 L -1 -1');
};

var index = (function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = compositionApi.isRef(opt) ? opt : compositionApi.ref(opt);
  return function (rootContext, _ref, onDestroy) {
    var installRootPlugin = _ref.installRootPlugin,
        installCalendarItemPlugin = _ref.installCalendarItemPlugin;

    var _useSelection = useSelection(rootContext.id, options),
        selection = _useSelection.selection,
        hoverItem = _useSelection.hoverItem,
        isHovered = _useSelection.isHovered,
        selectItem = _useSelection.selectItem,
        isSelectable = _useSelection.isSelectable,
        isSelected = _useSelection.isSelected,
        isWithinSelection = _useSelection.isWithinSelection,
        isBeforeMinDate = _useSelection.isBeforeMinDate,
        isAfterMaxDate = _useSelection.isAfterMaxDate,
        analysis = _useSelection.analysis,
        hasReservation = _useSelection.hasReservation,
        stopHandles = _useSelection.stopHandles,
        destroy = _useSelection.destroy,
        clearSelection = _useSelection.clear;

    compositionApi.onMounted(function () {
      stopHandles.value.push(compositionApi.watch(function () {
        return options.value.colors;
      }, function (colors) {
        for (var state in colors) {
          var stateColors = colors[state];

          for (var key in stateColors) {
            var color = stateColors[key];
            document.documentElement.style.setProperty(styles.cssVar("sel-color-".concat(state, "-").concat(key)), color);
          }
        }
      }));
    });
    onDestroy(function () {
      destroy();

      for (var state in options.value.colors) {
        var stateColors = options.value.colors[state];

        for (var key in stateColors) {
          document.documentElement.style.removeProperty(styles.cssVar("sel-color-".concat(state, "-").concat(key)));
        }
      }
    });
    stopHandles.value.push(compositionApi.watch(selection, function (sel) {
      if ((sel.from || sel.to) && options.value.onSelect) {
        // @ts-ignore
        var from = sel.from ? typeof options.value.dateFormat === 'undefined' ? sel.from.date : dateFns.format(sel.from.date, options.value.dateFormat) : null; // @ts-ignore

        var to = sel.to ? typeof options.value.dateFormat === 'undefined' ? sel.to.date : dateFns.format(sel.to.date, options.value.dateFormat) : null;
        options.value.onSelect.apply(options, [{
          from: from,
          to: to
        }]);
      }
    }, {
      deep: true
    }));
    installRootPlugin({
      on: {
        keyup: function keyup(el, ev) {
          if (ev.key === 'Escape') {
            clearSelection(selection);
          }
        }
      }
    });
    installCalendarItemPlugin({
      classes: function classes(item) {
        var classes = [];

        if (!item.isCurrentMonth) {
          return classes;
        }

        var selectable = isSelectable(item, analysis.value, options.value);
        var blocked = hasReservation(item, analysis.value);
        var hovered = isHovered(item);
        var withinSelection = isWithinSelection(item);
        var selected = isSelected(item);
        var highlighted = options.value.highlight ? options.value.highlight(item, {
          hovered: hovered,
          selectable: selectable,
          selected: selected,
          withinSelection: withinSelection,
          blocked: blocked
        }) : false;
        var blockedStartDay = false;
        var blockedEndDay = false;

        if (options.value.reservations && options.value.reservations.allowCheckInOutOverlap) {
          var blockedRanges = findRangesOfItem(item, options.value.reservations ? options.value.reservations.ranges : undefined);
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = blockedRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var range = _step.value;

              if (dateFns.isSameDay(range.start, item.date)) {
                blockedStartDay = true;
              }

              if (dateFns.isSameDay(range.end, item.date)) {
                blockedEndDay = true;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        if (selectable) {
          classes.push('is-selectable');
        } else {
          classes.push('is-unselectable');
        }

        if (hovered) {
          classes.push('is-hovered');
        }

        if (withinSelection) {
          classes.push('is-within-selection');
        }

        if (selected) {
          classes.push('is-selected');
        }

        if (highlighted) {
          classes.push('is-highlighted');
        }

        if (blocked) {
          classes.push('is-blocked');
        }

        if (!(blockedStartDay && blockedEndDay)) {
          if (blockedStartDay) {
            classes.push('is-blocked-start-day');
          }

          if (blockedEndDay) {
            classes.push('is-blocked-end-day');
          }
        }

        return classes;
      },
      styles: function styles(item, classes, ctx) {
        var styles = {};

        if (!options.value.css) {
          return styles;
        }

        if (options.value.css.base) {
          styles = Object.assign({}, styles, {}, options.value.css.base);
        }

        if (options.value.css.selectable && classes.indexOf('is-selectable') > -1) {
          styles = Object.assign({}, styles, {}, options.value.css.selectable);
        }

        if (options.value.css.unselectable && classes.indexOf('is-unselectable') > -1) {
          styles = Object.assign({}, styles, {}, options.value.css.unselectable);
        }

        if (options.value.css.hovered && classes.indexOf('is-hovered') > -1) {
          styles = Object.assign({}, styles, {}, options.value.css.hovered);
        }

        if (options.value.css.withinSelection && classes.indexOf('is-within-selection') > -1) {
          styles = Object.assign({}, styles, {}, options.value.css.withinSelection);
        }

        if (options.value.css.selected && classes.indexOf('is-selected') > -1) {
          styles = Object.assign({}, styles, {}, options.value.css.selected);
        }

        if (options.value.css.highlighted && classes.indexOf('is-highlighted') > -1) {
          styles = Object.assign({}, styles, {}, options.value.css.highlighted);
        }

        if (options.value.css.blocked && classes.indexOf('is-blocked') > -1) {
          styles = Object.assign({}, styles, {}, options.value.css.blocked);
        }

        return styles;
      },
      on: {
        click: function click(item) {
          if (isSelectable(item, analysis.value, options.value)) {
            selectItem(item, selection);
          }
        },
        mouseenter: function mouseenter(item) {
          if (!item.isCurrentMonth || isBeforeMinDate(item, options.value.minDate) || isAfterMaxDate(item, options.value.maxDate)) {
            hoverItem.value = null;
            return;
          }

          hoverItem.value = item;
        },
        mouseleave: function mouseleave(item) {
          if (hoverItem.value === item) {
            hoverItem.value = null;
          }
        }
      },
      calendarItemRenderFn: function calendarItemRenderFn(h, prev, _ref2) {
        var classes = _ref2.classes;

        if (!(options.value.reservations && options.value.reservations.allowCheckInOutOverlap)) {
          return prev;
        }

        if (classes.indexOf('is-hovered') > -1 || classes.indexOf('is-selected') > -1) {
          return prev;
        }

        if (classes.indexOf('is-blocked-start-day') > -1) {
          prev.children.unshift(renderCheckInDay(h));
        }

        if (classes.indexOf('is-blocked-end-day') > -1) {
          prev.children.unshift(renderCheckOutDay(h));
        }

        return prev;
      }
    });
  };
});

module.exports = index;
